import React from 'react';
import { Picture } from 'components/UI';
import { gfxFeatures, iconCheckmark } from 'assets';

const Features = () => {
  const bulletList = (label) => (
    <li className="flex mb-6">
      <img alt="check" src={iconCheckmark.default} className="h-4 mt-1 mr-4" />
      <span>{label}</span>
    </li>
  );

  return (
    <div className="container flex flex-col-reverse lg:flex-row items-center my-24 mx-auto px-4">
      <div className="flex flex-col items-center lg:items-start lg:w-1/2">
        <h2 className="hidden lg:block">Features At a Glance</h2>
        <p className="text-md text-dusty my-8 lg:mb-16 text-center lg:text-left">
          Stay updated, share insights and feel connected all in one app
        </p>
        <div className="flex justify-center">
          <ul className="list-outside px-6 sm:px-24 lg:pl-0">
            {bulletList(
              'Connect, chat and collaborate with music industry professionals'
            )}
            {bulletList(
              'Learn about various music markets across Asia Pacific through Articles and City Guides'
            )}
            {bulletList(
              'Participate in exclusive music industry events curated by Gig Life Pro'
            )}
            {bulletList(
              'Promote your own events to music industry professionals'
            )}
          </ul>
        </div>
      </div>
      <div className="flex-1">
        <h2 className="text-center lg:hidden">Features At a Glance</h2>
        <Picture src={gfxFeatures} />
      </div>
    </div>
  );
};

export default Features;
